import { DatePicker, Table } from 'antd';
import React, { useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { incomeStatementReportHeader } from '../../utils/TableData/Report/IncomeStatementReportHeader';

export default function IncomeStatementReport() {
  const [isLoading, setIsLoading] = useState(false);

  const [selectedFromDate, setSelectedFromDate] = useState('');
  const [selectedToDate, setSelectedToDate] = useState('');

  const [localIncomeStatementData, setLocalIncomeStatementData] = useState([]);
  return (
    <Container className="pt-3">
      <h2>Income Statement - Report</h2>
      <hr />
      <Row>
        <Col>
          <DatePicker.RangePicker
            onChange={(dates) => {
              const [start, end] = dates;
              setSelectedFromDate(start.format('YYYY-MM-DD'));
              setSelectedToDate(end.format('YYYY-MM-DD'));
            }}
            format="YYYY-MM-DD"
            placeholder={['Start Date', 'End Date']}
            style={{ height: '40px', width: '100%' }}
            disabled={isLoading}
          />
        </Col>
        <Col>
          <Button
            variant="secondary"
            disabled={
              isLoading || selectedFromDate === '' || selectedToDate === ''
            }
            onClick={() => {
              setIsLoading(true);
              setTimeout(() => {
                setIsLoading(false);
              }, 3000);
            }}
            className="mb-3 w-100"
          >
            {isLoading ? 'Loading...' : 'Process'}
          </Button>
        </Col>
      </Row>
      <Table
        columns={incomeStatementReportHeader}
        dataSource={localIncomeStatementData}
        size="small"
        bordered="true"
        scroll={{ x: true }}
        loading={isLoading}
      />
    </Container>
  );
}
